import { useContext } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Box, Flex, Text } from 'rebass'
import { makeDate } from '../../utils/helpers'
import { DataContext } from '../../contexts/dataContext'
import { lang } from '../../utils/lang'
import SmImg from '../../assets/thumb_small.png'

//shift is used by timeline tooltip
//isCluster is used by map tooltop
const ToolTipBox = styled(Box)`
  display: none;
  @media (hover: hover) and (any-hover: hover) and (any-pointer: fine) and (pointer: fine) {
    display: ${(props) => (props.show ? 'block' : 'none')};
    white-space: nowrap;
    background-color: rgba(0, 0, 0, 0.75);
    position: absolute;
    top: -6.75rem;
    left: ${(props) =>
      props.ui === 'en'
        ? props.shift
          ? ''
          : '-7rem'
        : props.shift
        ? '-3rem'
        : ''};
    right: ${(props) =>
      props.ui === 'en'
        ? props.shift
          ? '-3rem'
          : ''
        : props.shift
        ? ''
        : '-7rem'};
    z-index: 10;
    //padding: 0.75rem;
    color: ${(props) => props.theme.colors.white};
    border-radius: 4px;

    //triangle pointer:
    ::after {
      content: '';
      position: absolute;
      top: 100%;
      left: ${(props) =>
        props.ui === 'en'
          ? props.shift
            ? ''
            : '6.6rem'
          : props.shift
          ? '2.6rem'
          : ''};
      right: ${(props) =>
        props.ui === 'en'
          ? props.shift
            ? '2.6rem'
            : ''
          : props.shift
          ? ''
          : '6.6rem'};
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 16px solid rgba(0, 0, 0, 0.75);
    }
  }
`
const Pic = styled(Box)`
  border: ${(props) => (props.noImg ? `1px solid white` : null)};
  margin: 0.5rem;
  width: 4rem;
  height: 4.75rem;
  img {
    border-radius: ${(props) =>
      props.ui === 'en' ? '0.25rem 0 0 0.25rem' : '0 0.25rem  0.25rem 0'};
    width: 4rem;
    height: calc(4.75rem - 2px);
    object-fit: cover;
  }
`
const Name = styled(Text)`
  font-family: ${(props) => props.theme.fonts.condensed};
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.4;
  color: white;
  z-index: 15;
`
const DateHeader = styled(Text)`
  font-weight: 400;
  font-size: ${(props) => (props.ui === 'en' ? '0.65rem' : '.75rem')};
  text-transform: uppercase;
`
const LocationHeader = styled(Text)`
  font-weight: 400;
  font-size: ${(props) => (props.ui === 'en' ? '0.65rem' : '.75rem')};
  text-transform: uppercase;
`
const ClickText = styled(Text)`
  font-style: italic;
  font-size: 0.75rem;
  font-weight: 400;
  text-align: ${(props) => (props.ui === 'en' ? 'right' : 'left')};
`
const TimelineToolTip = ({
  show,
  d,
  shift //for timeline tooltip
}) => {
  const { ui } = useContext(DataContext)
  const dir = ui === 'en' ? 'ltr' : 'rtl'

  return (
    <ToolTipBox shift={shift} show={show} dir={dir} ui={ui}>
      <Flex>
        <Pic noImg={d.photoUrlSm ? false : true} ui={ui}>
          <img src={d.photoUrlSm || SmImg} alt={d.fnames + ' ' + d.sname} />
        </Pic>
        <Box py={2} pl={ui === 'en' ? 1 : 3} pr={ui === 'en' ? 3 : 1}>
          <Name>
            {!d.fnames && !d.sname
              ? lang[ui]['UnknownPerson']
              : `${d.fnames} ${d.sname}`}
          </Name>
          <Flex alignItems="center" mt={'-2px'}>
            <DateHeader ui={ui}>{lang[ui]['Date']}:&nbsp;</DateHeader>
            <Text
              fontWeight="400"
              fontSize=".8rem"
              mt={ui === 'fa' ? '.05rem' : 0}
            >
              {/* {d.month && d.month !== '00' ? MONTHS[d.month] : ''}
              {d.day ? ' ' + d.day : ''}
              {d.day || d.month !== '00' ? ', ' : ''}
              {d.year} */}
              {!d.date || d.date === '0'
                ? lang[ui]['Unknown']
                : makeDate(d.date, ui)}
            </Text>
          </Flex>

          <Flex alignItems="center" mt={'-2px'} dir={dir}>
            <LocationHeader ui={ui}>
              {lang[ui]['Location']}: &nbsp;
            </LocationHeader>
            <Text
              fontWeight="400"
              fontSize=".8rem"
              mt={ui === 'fa' ? '.05rem' : 0}
            >
              {d.location}
            </Text>
          </Flex>
          <ClickText
            m={
              ui === 'en'
                ? '0.25rem 0 -0.35rem 1rem'
                : '0.25rem 1rem -0.35rem 0'
            }
            ui={ui}
          >
            {lang[ui]['click to read']}
          </ClickText>
        </Box>
      </Flex>
    </ToolTipBox>
  )
}

export default TimelineToolTip

TimelineToolTip.propTypes = {
  show: PropTypes.bool.isRequired,
  d: PropTypes.object,
  shift: PropTypes.bool
}
